export enum SecurityLevelType {
    public = 'public',
    private = 'private',
    non = '',
}

export enum PermissionType {
    read_only = 'read_only',
    read_write = 'read_write',
    non = '',
}
export interface PermissionInfo
{
    permission : PermissionType;
    tenant_id: string;
    group_id : string;
}
